export default "__VITE_ASSET__47dd88e9__"